import { Options, Prop, Vue } from "vue-property-decorator";
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';

@Options({
  components: {
    LoadingSpinner,
  },
  emits: ['update:isSectionLoading'],
  mixins: [FormatDateTimeMixin],
})
export default class FormEerConfirmation extends Vue {
  @Prop({ default: false })
  private isSectionLoading!: boolean;


  
  mounted(): void {
    this.$emit('update:isSectionLoading', false);
  }

}
